import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CommunityDetails from './CommunityDetails';

const CommunityScene = () => (
  <Routes>
    <Route
      path=":tab?/:action?/:actionId?"
      element={<CommunityDetails menuName="communities" />}
    />
  </Routes>
);

export default CommunityScene;
